import Topnavbar from "../../../Layouts/Topnavbar"
import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, Button, Drawer, Select, Divider, TextInput } from "@mantine/core";
import React, { useState, useEffect } from "react";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    Input,
    Space,
    Card, message, Descriptions,
} from "antd";
import { Get_All_Users, User_Swap } from "../../../apicall";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";












const Swapuser = ({ Headername }) => {
    const { user } = Userauthcontexthooks();
    const [userfindloading, setUserloading] = useState(true);
    const [mappedUsers, setMappedUsers] = useState({
        retailerLists: [],
        distributorsLists: [],
        masterDistributorLists: []
    });
    const [Swapuser, setSwapuser] = useState({
        userType: "", // which type need to change onlt ret and dist allowed
        selectedUser: null, // get the details swapid
        inheritedDist: null,
        inheritedMasterdist: null,
    });
    const [swapLoading, setSwaploading] = useState(false);

    const handleUserTypeChange = async (value) => {
        setSwapuser((prev) => ({
            ...prev,
            userType: value,
            selectedUser: null,
        }));
        try {
            setUserloading(true);
            const data = await Get_All_Users();
            if (data.success) {
                //console.log(data);
                setMappedUsers({
                    retailerLists: data?.retailerLists,
                    distributorsLists: data?.distributorsLists,
                    masterDistributorLists: data?.masterDistributorLists,
                })
                //setWalletTransferHistory(data.transferHistory);
                //setFilteredWalletTransferHistory(data.transferHistory);
            }

        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setUserloading(false);
        }
    };
    const handleSwapInput = (field, value) => {
        setSwapuser((prev) => ({
            ...prev,
            [field]: value,
        }));
    };
    const retailerOptions = mappedUsers?.retailerLists?.map((item) => ({
        value: item._id,
        label: `${item.userName} (${item.userCode})`,
    })) || [];

    const distributorOptions = mappedUsers?.distributorsLists?.map((item) => ({
        value: item._id,
        label: `${item.userName} (${item.userCode})`,
    })) || [];

    const masterDistributorOptions = mappedUsers?.masterDistributorLists?.map((item) => ({
        value: item._id,
        label: `${item.userName} (${item.userCode})`,
    })) || [];

    const selectedUser = Swapuser?.userType === "Retailer"
        ? mappedUsers?.retailerLists?.find(
            (x) => x?._id === Swapuser?.selectedUser
        )
        : Swapuser?.userType === "Distributor" ? mappedUsers?.distributorsLists?.find(
            (x) => x?._id === Swapuser?.selectedUser
        ) : mappedUsers?.masterDistributorLists?.find(
            (x) => x?._id === Swapuser?.selectedUser)

    const confirmSwap = async () => {
        const { userType, inheritedDist, inheritedMasterdist } = Swapuser;
        if (!userType || !inheritedDist || !inheritedMasterdist) {
            message.error("All fields are required");
            return;
        }
        // const transferDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
        const selectedUser = Swapuser?.userType === "Retailer"
            ? mappedUsers?.retailerLists?.find(
                (x) => x?._id === Swapuser?.selectedUser
            )
            : Swapuser?.userType === "Distributor" ? mappedUsers?.distributorsLists?.find(
                (x) => x?._id === Swapuser?.selectedUser
            ) : mappedUsers?.masterDistributorLists?.find(
                (x) => x?._id === Swapuser?.selectedUser)

        const body = {
            usertype: userType,
            distid: inheritedDist,
            mdistid: inheritedMasterdist,
            swapUserid: selectedUser?._id
        }
        // console.log(body);
        try {
            setSwaploading(true);
            // API CALL HERE
            const data = await User_Swap(body);
            if (data.success) {
                message.success(data.message);
                setSwapuser({
                    userType: "", // which type need to change onlt ret and dist allowed
                    selectedUser: null, // get the details swapid
                    inheritedDist: null,
                    inheritedMasterdist: null,
                })
            }

        } catch (error) {

            console.log(error);

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setSwaploading(false);
        }

    };

    useEffect(() => {
        // const GetUserprofile = async () => {
        //     try {
        //         const data = await Get_User_Details();
        //         if (data.success) {
        //             //console.log(data);
        //             //setProfiledetails(data?.user)
        //         }
        //     } catch (error) {
        //         console.log(error);
        //         message.error(
        //             error.response?.data?.message ||
        //             "Something went wrong."
        //         );
        //     } finally {
        //         setUserprofileLoading(false);
        //         setledgerloading(false);
        //     }
        // }
        const fetchusers = async () => {

            try {
                const data = await Get_All_Users();
                if (data.success) {
                    //console.log(data);
                    setMappedUsers({
                        retailerLists: data?.retailerLists,
                        distributorsLists: data?.distributorsLists,
                        masterDistributorLists: data?.masterDistributorLists,
                    })
                }
            } catch (error) {

                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setUserloading(false);
            }

        }
        if (user) {
            // fetchuserledger();
            fetchusers();
        }

    }, [user]);

    return (
        <>
            <Topnavbar Headername={Headername} />

            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Swap User</Title>
                <Text size="xs">Change user inhertiance</Text>
            </Container>

            <Container size={'lg'} mt={'lg'} mb={'sm'}>
                <Grid>
                    <Grid.Col span={{ xs: 12, sm: 12, md: 12 }}>
                        <Paper shadow="sm" p={'xs'}>
                            <Select
                                label="Select User Type"
                                placeholder="Select User Type"
                                withAsterisk
                                mt="xs"
                                data={['Retailer', 'Distributor']}
                                value={Swapuser.userType}
                                onChange={handleUserTypeChange}
                                // loading={userprofileLoading}
                                style={{ width: "100%" }}
                            />
                            {Swapuser.userType === "Retailer" && (
                                <>
                                    <Select
                                        label="Select Retailer"
                                        placeholder="Choose Retailer"
                                        searchable
                                        clearable
                                        nothingFoundMessage="No retailer found"
                                        withAsterisk
                                        mt="xs"
                                        data={retailerOptions}
                                        value={Swapuser.selectedUser}
                                        onChange={(value) =>
                                            handleSwapInput("selectedUser", value)
                                        }
                                        comboboxProps={{
                                            withinPortal: false,
                                        }}
                                        loading={userfindloading}
                                    />
                                    <Group mt={'xs'} justify="space-even">
                                        <TextInput label="Master distributor name" value={selectedUser?.master_dist_id?.userName} readOnly />
                                        <TextInput label="Master distributor code" value={selectedUser?.master_dist_id?.userCode} readOnly />
                                        <TextInput label="Distributor name" value={selectedUser?.distributor_id?.userName} readOnly />
                                        <TextInput label="Distributor code" value={selectedUser?.distributor_id?.userCode} readOnly />
                                    </Group>

                                </>
                            )}
                            {Swapuser.userType === "Distributor" && (
                                <>
                                    <Select
                                        label="Select Distributor"
                                        placeholder="Choose Distributor"
                                        searchable
                                        clearable
                                        nothingFoundMessage="No distributor found"
                                        withAsterisk
                                        mt="xs"
                                        data={distributorOptions}
                                        value={Swapuser.selectedUser}
                                        onChange={(value) =>
                                            handleSwapInput("selectedUser", value)
                                        }
                                        comboboxProps={{
                                            withinPortal: false,
                                        }}
                                        loading={userfindloading}
                                    />
                                    <Group mt={'xs'} justify="space-even">
                                        <TextInput label="Master distributor name" value={selectedUser?.master_dist_id?.userName} readOnly />
                                        <TextInput label="Master distributor code" value={selectedUser?.master_dist_id?.userCode} readOnly />
                                    </Group>
                                </>
                            )}
                            {/* {Swapuser.userType === "Master Distributor" && (
                                <Select
                                    label="Select Master Distributor"
                                    placeholder="Choose Master Distributor"
                                    searchable
                                    clearable
                                    nothingFoundMessage="No master distributor found"
                                    withAsterisk
                                    mt="xs"
                                    data={masterDistributorOptions}
                                    value={Swapuser.selectedUser}
                                    onChange={(value) =>
                                        handleSwapInput("selectedUser", value)
                                    }
                                    comboboxProps={{
                                        withinPortal: false,
                                    }}
                                    loading={userfindloading}
                                />
                            )} */}
                            <Divider variant="dashed" label="Select new distributors" mt={'xs'} />
                            {(Swapuser.selectedUser) && (
                                <Select
                                    label="Select New Master Distributor"
                                    placeholder="Choose Master Distributor"
                                    searchable
                                    clearable
                                    nothingFoundMessage="No master distributor found"
                                    withAsterisk
                                    mt="xs"
                                    data={masterDistributorOptions}
                                    value={Swapuser.inheritedMasterdist}
                                    onChange={(value) =>
                                        handleSwapInput("inheritedMasterdist", value)
                                    }
                                    comboboxProps={{
                                        withinPortal: false,
                                    }}
                                    loading={userfindloading}
                                />
                            )}

                            {(Swapuser.userType === "Retailer" && Swapuser.selectedUser) && (
                                <Select
                                    label="Select New Distributor"
                                    placeholder="Choose Distributor"
                                    searchable
                                    clearable
                                    nothingFoundMessage="No distributor found"
                                    withAsterisk
                                    mt="xs"
                                    data={distributorOptions}
                                    value={Swapuser.inheritedDist}
                                    onChange={(value) =>
                                        handleSwapInput("inheritedDist", value)
                                    }
                                    comboboxProps={{
                                        withinPortal: false,
                                    }}
                                    loading={userfindloading}
                                />
                            )}

                            <Button
                                fullWidth
                                variant="light"
                                mt="md"
                                loading={swapLoading}
                                onClick={confirmSwap}
                            >
                                Swap - {selectedUser?.userName}
                            </Button>
                            {/* <TextInput
                                label="Transfer Amount"
                                placeholder="0.00"
                                withAsterisk
                                mt="xs"
                                value={transferForm.amount}
                                onChange={(e) =>
                                    handleTransferInput("amount", e.target.value)
                                }
                            />
                            <Textarea
                                label="Remarks (Optional)"
                                placeholder="Write description here..."
                                mt="xs"
                                value={transferForm.remarks}
                                onChange={(e) =>
                                    handleTransferInput("remarks", e.target.value)
                                }
                            />
                            <Button
                                fullWidth
                                variant="light"
                                mt="md"
                                onClick={handleTransferSubmit}
                            >
                                Transfer Amount
                            </Button> */}
                        </Paper>
                    </Grid.Col>

                    {/* <Grid.Col span={{ xs: 12, sm: 12, md: 12 }}>
                        <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                            <Col xs={24} md={7}>
                                <Search
                                    placeholder="Search User Code or Revert ID"
                                    allowClear
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    onSearch={handleSearch}
                                />
                            </Col>
                            <Col xs={24} md={4}>
                                <Select
                                    value={status}
                                    onChange={setStatus}
                                    style={{ width: "100%" }}
                                    data={[
                                        { label: "All Status", value: "ALL" },
                                        { label: "SUCCESS", value: "SUCCESS" },
                                        { label: "PENDING", value: "PENDING" },
                                        { label: "FAILED", value: "FAILED" },
                                    ]}
                                />
                            </Col>
                            <Col xs={24} md={6}>
                                <Space>
                                    <Button
                                        type="primary"
                                        onClick={handleSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        variant="light"
                                        onClick={handleReset}
                                    >
                                        Reset
                                    </Button>

                                    <Button
                                        variant="outline"
                                        onClick={fetchFundTransferHistory}
                                    >
                                        Refresh
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                        <Paper shadow="sm" p={'xs'}>
                            <Table
                                columns={columns}
                                dataSource={filteredFundTransferHistory}
                                rowKey="_id"
                                loading={historyLoading}
                                bordered
                                size="middle"
                                pagination={{
                                    pageSize: 10,
                                    showSizeChanger: true,
                                }} />
                        </Paper>
                    </Grid.Col> */}
                </Grid>
            </Container>


        </>
    )
}

export default Swapuser